import { Draft } from './Draft';
import { PaymentRequest as PaymentRequestModel } from '@qover/domain';

export class PaymentRequest extends PaymentRequestModel<Draft> {
  constructor(draft: Draft, token: string, returnUrl: string) {
    super(draft, token, returnUrl, 'MONTHLY');
  }
}
